import { WorkspaceDetailsProvider } from './context/WorkspaceDetailsContext';
import { WorkspaceDetailsContainer } from './WorkspaceDetails';

export const WorkspaceDetails = () => (
    <WorkspaceDetailsProvider>
        <WorkspaceDetailsContainer />
    </WorkspaceDetailsProvider>
);
